import { Notification } from '../types';

export const mockNotifications: Notification[] = [
  {
    id: 1,
    user_id: 1,
    body: '<h3>Tu verificación fue aprobada</h3><p>Ahora puedes disfrutar de límites más altos y todas las funciones.</p><a href="/deposit">Servicio al cliente</a>',
    type: 'transactional-warning',
    read: false,
    deleted: false,
    created_at: new Date('2026-10-02T05:05:56Z'),
    updated_at: new Date('2026-10-02T05:05:56Z'),
  },
  {
    id: 2,
    user_id: 1,
    body: '<h3>¡Mantenimiento de pasarela de deposito!</h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    type: 'transactional',
    read: false,
    deleted: false,
    created_at: new Date('2026-10-01T23:11:56Z'),
    updated_at: new Date('2026-10-01T23:11:56Z'),
  },
  {
    id: 3,
    user_id: 1,
    body: '<h3>Tu verificación fue aprobada</h3><p>Ahora puedes disfrutar de límites más altos y todas las funciones.</p><a href="/deposit">Servicio al cliente</a>',
    type: 'kyc',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-12T20:30:00Z'),
    updated_at: new Date('2025-09-12T20:30:00Z'),
  },
  {
    id: 4,
    user_id: 1,
    body: '<h3>¡Atención! bono deportivo</h3><p>🎁 Para activar tu bono y hacer tu primer depósito, asegúrate de completar la validación de identidad. ¡Es rápido y seguro!</p><a href="/dashboard/kyc">Validar mi identidad</a>',
    type: 'promotions',
    read: false,
    deleted: false,
    created_at: new Date('2025-09-12T18:45:00Z'),
    updated_at: new Date('2025-09-12T18:45:00Z'),
  },
  {
    id: 5,
    user_id: 1,
    body: '<h3>¡Tu bono deportivo, esta listo</h3><p>🎁 Para activar tu bono y hacer tu primer depósito, asegúrate de completar la validación de identidad. ¡Es rápido y seguro!</p><a href="/promotions">Saber más</a>',
    type: 'promotions',
    read: false,
    deleted: false,
    created_at: new Date('2025-09-12T16:20:00Z'),
    updated_at: new Date('2025-09-12T16:20:00Z'),
  },
  {
    id: 6,
    user_id: 1,
    body: '<h3>Depósito exitoso</h3><p>Tu depósito de L. 500.00 ha sido procesado exitosamente. ¡Disfruta jugando!</p>',
    type: 'transactional',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-11T14:22:00Z'),
    updated_at: new Date('2025-09-11T14:22:00Z'),
  },
  {
    id: 7,
    user_id: 1,
    body: '<h3>¡Bienvenido a Hondubet!</h3><p>Gracias por registrarte. Completa tu perfil y realiza tu primer depósito para obtener un bono de bienvenida.</p><a href="/deposit">Hacer depósito</a>',
    type: 'promotions',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-10T10:15:00Z'),
    updated_at: new Date('2025-09-10T10:15:00Z'),
  },
  {
    id: 8,
    user_id: 1,
    body: '<h3>Actualización de términos y condiciones</h3><p>Hemos actualizado nuestros términos y condiciones. Por favor, revísalos para continuar usando nuestros servicios.</p><a href="/info/terminos">Leer más</a>',
    type: 'system',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-09T09:00:00Z'),
    updated_at: new Date('2025-09-09T09:00:00Z'),
  },
  {
    id: 9,
    user_id: 1,
    body: '<h3>Retiro procesado</h3><p>Tu solicitud de retiro de L. 1,200.00 ha sido procesada y el dinero está en camino a tu cuenta.</p>',
    type: 'transactional',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-08T16:45:00Z'),
    updated_at: new Date('2025-09-08T16:45:00Z'),
  },
  {
    id: 10,
    user_id: 1,
    body: '<h3>¡Nuevo torneo disponible!</h3><p>Participa en nuestro torneo semanal de slots y gana increíbles premios. ¡No te lo pierdas!</p><a href="/tournaments">Ver torneos</a>',
    type: 'promotions',
    read: true,
    deleted: false,
    created_at: new Date('2025-09-07T12:00:00Z'),
    updated_at: new Date('2025-09-07T12:00:00Z'),
  },
];
